if (!customElements.get('agb-checkbox')) {
  class AgbCheckbox extends HTMLElement {
    connectedCallback() {
      this.button = document.getElementById(this.dataset.checkoutButton);
      if (!this.button) return;

      this._onCheckout = this.onCheckout.bind(this);
      this.button.addEventListener('click', this._onCheckout, true);
      this.addEventListener('change', () => this.clearError());
    }

    disconnectedCallback() {
      if (this.button && this._onCheckout) {
        this.button.removeEventListener('click', this._onCheckout, true);
      }
    }

    onCheckout(event) {
      const invalid = this.firstInvalid();
      if (!invalid) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.showError(invalid.message);
      if (invalid.input && typeof invalid.input.focus === 'function') {
        invalid.input.focus();
      }
    }

    firstInvalid() {
      const primary = this.querySelector('.agb-check__primary input[type="checkbox"]');
      const secondary = this.querySelector('.agb-check__secondary input[type="checkbox"]');

      if (primary && !primary.checked) {
        return { input: primary, message: this.dataset.errorPrimary };
      }
      if (secondary && !secondary.checked) {
        return { input: secondary, message: this.dataset.errorSecondary };
      }
      return null;
    }

    showError(message) {
      if (message) window.alert(message);
    }

    clearError() {
      const box = this.querySelector('.agb-check__error');
      if (box) {
        box.hidden = true;
        box.textContent = '';
      }
      this.classList.remove('agb-check--error');
    }
  }

  customElements.define('agb-checkbox', AgbCheckbox);
}
